//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { applyDrag } from "../utils/helpers";
import { mapGetters, mapActions } from "vuex";
import EditMediaModal from "./Media/EditMediaModals/EditMediaModal";
import ContentCard from "./Media/ContentCard.vue";
import PlaylistContentCard from "./PlaylistContentCard.vue";
import AddMediaButton from "./Media/AddMediaButton.vue";
import GroupCards from "./GroupCards.vue";
import MediaView from "./MediaView.vue";
import DeviceTabPanels from "./DeviceTabPanels.vue";
import PlaylistCard from "./PlaylistCard.vue";
import PlaylistTabPanels from "./PlaylistTabPanels.vue";

export default {
  components: {
    ContentCard,
    PlaylistContentCard,
    AddMediaButton,
    GroupCards,
    MediaView,
    DeviceTabPanels,
    PlaylistCard,
    PlaylistTabPanels,
  },

  computed: {
    ...mapGetters(["allMediaFiles", "allDeviceGroups", "allDeviceGroupSelectOptions", "allUserPlaylists", "getMediaFilesForPlaylist", "playlistNameAlreadyTaken", "filterDevices"]),
  },
  props: ["title", "deviceView"],
  data() {
    return {
      groupDialog: false,
      searchTerm: "",
      info: "",
      groups: [],
      devices: [],
      tab: "firstTab",
      playlist: [],

      // index of the last add event from on drop
      lastAddedIndex: -1,
      lastPlaylistToAddIndex: -1,

      // last removed item from on drop
      lastRemovedItem: null,

      DeviceGroup: "",
      uploadPercentage: "",
      processing: false,
      newGroupName: "",
      error: "",
      add: false,
      newDeviceName: "",
      activationCode: "",

      openGroups: [],
      activeGroup: null,
      activeDevice: null,
      activePlaylist: null,
      plDialog: false,
      error: null,
      plName: "",
      plColor: "#ababab",
    };
  },
  mounted() {
    this.fetchAllUserPlaylists(true);

    const group = this.allDeviceGroups[0];
    if (group) {
      this.DeviceGroup = { label: group.GNAME, value: group };
    }

    this.interval = setInterval(() => {
      if (this.$store.getters.isLoggedIn) this.fetchDeviceGroups();
    }, 58000);

    if (this.$route.query.add == "true") {
      // show add device or add playlist dialog
      if (this.deviceView) {
        this.add = true;
      } else {
        this.plDialog = true;
      }
    }
  },
  onUpdate() {
    this.activePlaylist = null;
    this.activeDevice = null;
    this.activeGroup = null;
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  async created() {
    if (!this.$store.getters.isLoggedIn && this.$router.currentRoute.path !== "/login") {
      this.$router.push("/login");
    }

    this.fetchMediaFiles();
    this.fetchDeviceGroups();
  },

  watch: {
    activeGroup(newVal, oldVal) {
      // called when the group was changed
      if (newVal && oldVal && newVal.GID === oldVal.GID) {
        this.closeAllGroups();
      } else {
        const index = this.allDeviceGroups.indexOf(newVal);

        if (index >= 0) {
          this.DeviceGroup = {
            label: this.allDeviceGroups[index].GNAME,
            value: this.allDeviceGroups[index],
          };

          if (this.filterDevices(newVal.GID, this.searchTerm).length > 0) {
            this.openGroups[index] = true;
          }
        }
      }
    },
    activeDevice(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchDeviceGroups();
      }
    },
  },

  methods: {
    ...mapActions(["fetchMediaFiles", "fetchDeviceGroups", "addDeviceGroup", "fetchAllUserPlaylists", "updatePlaylistContentV2", "createPlaylist", "addDevice"]),
    editMedia(content) {
      this.$q.dialog({
        component: EditMediaModal,

        root: this,

        text: "something",
        content: content,
      });
    },
    openAllGroups() {
      for (let i = 0; i < this.allDeviceGroups.length; i++) {
        const group = this.allDeviceGroups[i];

        if (this.filterDevices(group.GID, this.searchTerm).length > 0) {
          this.openGroups[i] = true;
        }
      }
    },
    closeAllGroups() {
      for (let i = 0; i < this.allDeviceGroups.length; i++) {
        const group = this.allDeviceGroups[i];

        if (this.filterDevices(group.GID, this.searchTerm).length > 0) {
          this.openGroups[i] = false;
        }
      }
    },
    createPL(playlistName, playlistColor) {
      this.error = null;

      if (playlistName == "" || playlistName == null || playlistName == " ") {
        this.error = "Please enter a name";
      } else {
        if (this.playlistNameAlreadyTaken(playlistName)) {
          this.error = "Name already in use";
        } else {
          // remove # from color
          if (playlistColor.includes("#")) {
            playlistColor = playlistColor.substring(1);
          }

          const plinfo = {
            plName: playlistName,
            plColor: playlistColor,
          };

          this.createPlaylist(plinfo).then(() => {
            this.plName = "";
            this.plColor = "#ababab";
            this.fetchAllUserPlaylists().then(() => {
              this.activePlaylist = this.allUserPlaylists[this.allUserPlaylists.length - 1];

              this.$tours["playlistTour"].nextStep();
            });
          });
          this.plDialog = false;
        }
      }
    },

    addNewGroup(name) {
      this.error = false;

      if (name == "" || name == null || name == " ") {
        this.error = "Please enter a name";
      } else {
        var a = this.groups.indexOf(name);

        if (a >= 0) {
          this.error = "Name alread in use";
        } else {
          try {
            this.addDeviceGroup(name);
            this.newGroupName = "";
            this.groupDialog = false;
          } catch (error) {
            console.log(error.response.data.msg);
          }
        }
      }
    },
    removePlItem(content, indexPL, indexContent, plid) {
      this.playlist[indexPL].contentIds.splice(indexContent, 1);

      this.updatePlaylistContentV2({
        content: this.playlist[indexPL].contentIds,
        playlistId: plid,
      });
    },

    closeMediaView() {
      this.activeDevice = null;
    },

    onDrop(collection, dropResult, PLID) {
      const { removedIndex, addedIndex, payload } = dropResult;

      console.log("lastPlaylistToAddIndex", this.lastPlaylistToAddIndex);

      // get current media files
      const contentArr = this.getMediaFilesForPlaylist(this.playlist[collection]);

      // check if we dropped a countent from another playlist
      if (payload.fromPlaylist) {
        dropResult.payload = contentArr[payload.index];

        if (addedIndex !== null && removedIndex === null) {
          if (!this.lastRemovedItem) {
            // save drop position
            this.lastAddedIndex = addedIndex;
            this.lastPlaylistToAddIndex = collection;
            return;
          } else {
            // add last removed item to current position
            dropResult.payload = this.lastRemovedItem;
            this.lastRemovedItem = null;
          }
        } else if (addedIndex === null && removedIndex !== null) {
          if (this.lastPlaylistToAddIndex >= 0) {
            // add current content to given position
            this.playlist[this.lastPlaylistToAddIndex].contentIds.splice(this.lastAddedIndex, 0, dropResult.payload.id);

            // need this here, because else the endpoint will never be called (see 1548)
            this.updatePlaylistContentV2({
              content: this.playlist[this.lastPlaylistToAddIndex].contentIds,
              playlistId: this.playlist[this.lastPlaylistToAddIndex].ID,
            });

            this.lastPlaylistToAddIndex = -1;
          } else {
            // save dropped item
            this.lastRemovedItem = dropResult.payload;
          }
        }
      } else {
        // overrrite media id of drop result with media
        dropResult.payload = this.allMediaFiles[payload.index];
      }

      // add new media into current media files
      var tmp = applyDrag(contentArr, dropResult);

      // get only the content ids of the new playlist
      let contentIds = [];
      tmp.forEach((content) => {
        if (content.contentGroup) {
          contentIds.push(content.contentGroupId);
        } else {
          contentIds.push(content.id);
        }
      });

      if (addedIndex != null) {
        this.updatePlaylistContentV2({
          content: contentIds,
          playlistId: PLID,
        }).then(() => {
          this.playlist[collection].contentIds = contentIds;
        });
      }
    },

    addNewDevice(newDeviceName, activationCode, DeviceGroup) {
      const requestBody = {
        deviceName: newDeviceName.trim(),
        deviceCode: activationCode,
        groupId: DeviceGroup.value.GID,
      };

      this.addDevice(requestBody).then((error) => {
        if (error) {
          this.error = error;
        } else {
          this.add = false;
          this.error = "";

          // show added group
          this.activeGroup = JSON.parse(JSON.stringify(DeviceGroup));
        }

        this.activationCode = "";
      });
    },
  },
};
